import { NextApiRequest, NextApiResponse } from 'next'

export async function handleShippingMethodsMock(
  req: NextApiRequest,
  res: NextApiResponse
) {
  // Always return 403 Forbidden for shipping methods
  return res.status(403).json({
    error: 'Forbidden',
    message: 'Access denied to shipping methods',
    code: 'SHIPPING_METHODS_ACCESS_DENIED',
  })
}
